export const DEFAULT_SUBMODALITY_ID = 1;
export const JUDICIAL_MODALITY_OPTIONS = 16;
export const MODALITIES_CONVENCIONAL_662 = [
  96, // Executante construtor
  97, // Executante prestador de serviço
  98, // Executante fornecedor
  72, // Executante concessionário
  95, // Manutenção corretiva
];
export const SUBMODALITY_ID_CIRCULAR_662 = 90;
